require('./brokerConfigDefaultItem.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @utils
const { FormattedText } = require('core/i18n').i18n;

const BrokerConfigDefaultItem = props => {
    const {text} = props;

    return (
        <div className="broker-config-default-item">
            <FormattedText value={text} />
        </div>
    );
};

BrokerConfigDefaultItem.propTypes = {
    text: PropTypes.string
}

module.exports = BrokerConfigDefaultItem;
